export const isEmpty = (v: unknown): boolean =>
  v == null || (typeof v === 'string' && v.trim() === '');

export function validateVersionName(name: string): string | null {
  if (isEmpty(name)) return 'Version name is required';
  if (name.length > 120) return 'Max length is 120 characters';
  return null;
}

export function validateFormats(arr: string[] | null | undefined): string | null {
  if (!arr || arr.length === 0) return 'Select at least one format';
  return null;
}
